import { basic, withUniqueClass } from "../../helpers/block-helpers";

export const videoInput = basic.input({
  id: "basic-input-video",
  label: "Video",
  description: "A video, use it to add any video file to your page via URL or upload a video file.",
  content: withUniqueClass(
    "vid",
    (cls) => `
      <div class="${cls}" style="position:relative;width:100%;max-width:900px;">
        <video controls style="width:100%;height:auto;border-radius:12px;display:block;">
          <source src="" type="video/mp4" />
        </video>
      </div>
    `
  ),
});
